import { FC, PropsWithChildren, createContext, useContext } from 'react';

interface IShowtimesContext {
  handleClickShowtime?: (data?: {
    movieId: number;
    sessionId: number;
    isAfterMidnight?: boolean;
    isThreeD?: boolean;
  }) => void;
}

const ShowtimesContext = createContext<IShowtimesContext>({});

type ShowtimesProviderProps = PropsWithChildren & IShowtimesContext;

export const ShowtimesProvider: FC<ShowtimesProviderProps> = ({
  children,
  handleClickShowtime,
}) => {
  return (
    <ShowtimesContext.Provider
      value={{
        handleClickShowtime,
      }}
    >
      {children}
    </ShowtimesContext.Provider>
  );
};

export const useShowtimesProvider = () => {
  return useContext(ShowtimesContext);
};
